import {
    GET_SALESORDER_REQUEST, GET_SALESORDER_SUCCESS, GET_SALESORDER_FAIL,
    CREATE_SALESORDER_REQUEST, CREATE_SALESORDER_SUCCESS, CREATE_SALESORDER_FAIL,
    UPDATE_SALESORDER_REQUEST, UPDATE_SALESORDER_SUCCESS, UPDATE_SALESORDER_FAIL,
    DELETE_SALESORDER_REQUEST, DELETE_SALESORDER_SUCCESS, DELETE_SALESORDER_FAIL,
    GET_CUSTOMERSALESORDER_REQUEST, GET_CUSTOMERSALESORDER_SUCCESS, GET_CUSTOMERSALESORDER_FAIL,
    GENERATE_PDF_REQUEST, GENERATE_PDF_SUCCESS, GENERATE_PDF_FAIL,
    ADD_SELECTED_INVOICE, REMOVE_SELECTED_INVOICE, ADD_MULTI_SELECTED_INVOICE,
    REMOVE_MULTI_SELECTED_INVOICE, CLEAR_SELECTED_INVOICE
} from "../types/salesOrderTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants';
import cogoToast from 'cogo-toast';
import { localStorageItems } from "../../utils/constant";
import { array } from "yup";

export const deleteSalesOrder = (id) => async (dispatch) => {

    dispatch({ type: DELETE_SALESORDER_REQUEST });
    let delRecordId = Buffer.from(id).toString('base64');
    try {

        const headerData = {
            "api_token": localStorageItems.apiToken,
            "customer_no": localStorageItems.customerNo,
            "user_id": localStorageItems.userId,
        }

        const { data } = await Axios.delete(`${APP_CONSTANT.BASE_URL}sales/sales-orders/delete/${delRecordId}`, {
            data: {
                "api_token": localStorageItems.apiToken,
                "customer_no": localStorageItems.customerNo,
                "user_id": localStorageItems.userId,

            },
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorageItems.apiToken,
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_SALESORDER_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        dispatch({ type: DELETE_SALESORDER_FAIL, payload: error.message })
    }
}

export const updateSalesOrder = (updateSOData) => async (dispatch) => {

    dispatch({ type: UPDATE_SALESORDER_REQUEST });
    let rf_number = Buffer.from(updateSOData.reference_number).toString('base64');
    try {

        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}sales/sales-orders/update/${rf_number}`, updateSOData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorageItems.apiToken,
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_SALESORDER_SUCCESS, payload: data });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/salesorder';
            })
        }

    } catch (error) {
        dispatch({ type: UPDATE_SALESORDER_FAIL, payload: error.message })
    }
}

export const createSalesOrder = (createSOData) => async (dispatch) => {

    dispatch({ type: CREATE_SALESORDER_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders/create`, createSOData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorageItems.apiToken,
                "Access-Control-Allow-Origin": "*"
            }
        });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/salesorder';
            })
        }

        dispatch({ type: CREATE_SALESORDER_SUCCESS, payload: data });


    } catch (error) {
        dispatch({ type: CREATE_SALESORDER_FAIL, payload: error.message })
    }
}

export const getSalesOrder = (itemsPerPage, searchValue, activePage, id, client_code = null, client_branch_code = null, customerInvoiceSO, defaultFilter = null, client_vehicle_code = null) => async (dispatch) => {
    dispatch({ type: GET_SALESORDER_REQUEST });

    try {
        if (id != null && id != undefined && customerInvoiceSO != true) {
            let headerData = {
                ...defaultFilter,
                "api_token": localStorageItems.apiToken,
                "customer_no": localStorageItems.customerNo,
                "user_id": localStorageItems.userId,
                'reference_number': id,
                "searchString": searchValue,
            }

            const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders`, headerData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorageItems.apiToken,
                    "Access-Control-Allow-Origin": "*"
                }
            });

            dispatch({ type: GET_SALESORDER_SUCCESS, payload: data });


        } else if (customerInvoiceSO && id) {
            if (id != null && id != undefined) {
                let headerData = {
                    ...defaultFilter,
                    "api_token": localStorageItems.apiToken,
                    "customer_no": localStorageItems.customerNo,
                    "user_id": localStorageItems.userId,
                    'client_code': id,
                    "searchString": searchValue,
                    "is_used": '0'

                }

                const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders?page=${activePage}`, headerData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": localStorageItems.apiToken,
                        "Access-Control-Allow-Origin": "*"
                    }
                });
                dispatch({ type: GET_SALESORDER_SUCCESS, payload: data });
                dispatch({ type: GET_CUSTOMERSALESORDER_SUCCESS, payload: data });

            }
        } else if (client_code || client_branch_code || client_vehicle_code) {
            let headerData = {
                'api_token': localStorage.getItem("apiToken"),
                'customer_no': localStorage.getItem("customerNo"),
                'user_id': localStorage.getItem("userId"),
                'itemPerPage': itemsPerPage,
                'client_code': client_code || null,
                'branch_code': client_branch_code || null,
                'vehicle_id': client_vehicle_code || null,
                "searchString": searchValue
            }

            const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders?page=${activePage}`, headerData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorageItems.apiToken,
                    "Access-Control-Allow-Origin": "*"
                }
            });
            dispatch({ type: GET_SALESORDER_SUCCESS, payload: data });
        }
        else {
            let headerData = {
                ...defaultFilter,
                "api_token": localStorageItems.apiToken,
                "customer_no": localStorageItems.customerNo,
                "user_id": localStorageItems.userId,
                'itemPerPage': itemsPerPage,
                "searchString": searchValue,
                ...(client_code ? { client_code } : {}),
                ...(client_branch_code ? { client_branch_code } : {})
                // ...({client_code, branch_code}) 

            }
            const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders?page=${activePage}`, headerData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorageItems.apiToken,
                    "Access-Control-Allow-Origin": "*"
                }
            });
            dispatch({ type: GET_SALESORDER_SUCCESS, payload: data });

        }
    } catch (error) {
        dispatch({ type: GET_SALESORDER_FAIL, payload: error.message })
    }
}



export const getCustomerSalesOrder = (customerData, edit) => async (dispatch) => {

    dispatch({ type: GET_CUSTOMERSALESORDER_REQUEST });
    try {

        const headerData = (customerData, edit) => {

            if (customerData && edit) {
                return {
                    "api_token": localStorageItems.apiToken,
                    "customer_no": localStorageItems.customerNo,
                    "user_id": localStorageItems.userId,
                    "client_code": customerData.billingPartyCode,
                    "is_used": "0",
                    "invoice_id": customerData.invoiceId,
                    "searchString": customerData.searchString,
                }
            } else {
                return {
                    "api_token": localStorageItems.apiToken,
                    "customer_no": localStorageItems.customerNo,
                    "user_id": localStorageItems.userId,
                    "client_code": customerData,
                    "is_used": "0",
                    "searchString": customerData.searchString,
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders`, headerData(customerData, edit), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorageItems.apiToken,
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_CUSTOMERSALESORDER_SUCCESS, payload: data });

    } catch (error) {
        dispatch({ type: GET_CUSTOMERSALESORDER_FAIL, payload: error.message })
    }
}

export const getGeneratedPdf = (invoiceNo) => async (dispatch) => {

    dispatch({ type: GENERATE_PDF_REQUEST });

    try {

        const headerData = {
            "api_token": localStorageItems.apiToken,
            "customer_no": localStorageItems.customerNo,
            "user_id": localStorageItems.userId,
            "invoice_no": invoiceNo
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-invoices/generate-invoice-pdf`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorageItems.apiToken,
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GENERATE_PDF_SUCCESS, payload: data });
        window.open(data.data)

    } catch (error) {
        dispatch({ type: GENERATE_PDF_FAIL, payload: error.message })
    }
}

export const selectSoData = (data) => async (dispatch) => {
    try {
        dispatch({ type: ADD_SELECTED_INVOICE, payload: data });
    } catch (error) {
        dispatch({ type: REMOVE_SELECTED_INVOICE, payload: error.message })
    }
}


export const clearSelectSoData = () => async (dispatch) => {
    try {
        dispatch({ type: CLEAR_SELECTED_INVOICE, payload: [] });
    } catch (error) {
        dispatch({ type: REMOVE_SELECTED_INVOICE, payload: error.message })
    }
}


export const setMultiSelectSoData = (data) => async (dispatch) => {
    try {
        dispatch({ type: ADD_MULTI_SELECTED_INVOICE, payload: data });
    } catch (error) {
        dispatch({ type: REMOVE_MULTI_SELECTED_INVOICE, payload: error.message })
    }
}